import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#A2001D\" d=\"M12 0C7.037 0 2.78 3.012.952 7.306h22.093C21.218 3.011 16.96.001 11.999.001\"></path><path fill=\"#496E2D\" d=\"M12 24c4.96 0 9.218-3.01 11.046-7.304H.953C2.781 20.99 7.038 24.001 12 24.001\"></path><path fill=\"#0052B4\" d=\"M23.587 8.87H.413A12 12 0 0 0 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13s-.144-2.132-.413-3.13\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }